import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
   handleWorldpos
} from '../services/store'

// LOGIN INTO STORE
export const createNewStore = createAsyncThunk('store/createNewStore', async (args, { getState }) => {
    if (args["origin"]=="worldpos"){
        args["action"]= "createStore";
        args["collection"]= "storesWld";
    }
    const response = await handleWorldpos(args);
    return { response: response.data, statusCode: response.status };
});

export const loginStore = createAsyncThunk('store/loginStore', async (args, { getState }) => {
    if (args["origin"]=="worldpos"){
        args["action"]= "login";
        args["collection"]= "storesWld";
    }
    const response = await handleWorldpos(args);
    return { response: response.data, statusCode: response.status };
});

export const loginStoreAuto = createAsyncThunk('store/loginStoreAuto', async (args, { getState }) => {
    if (args["origin"]=="worldpos"){
        args["action"]= "auto";
        args["collection"]= "storesWld";
    }
    const response = await handleWorldpos(args);
    return { response: response.data, statusCode: response.status };
});

export const getListTrx = createAsyncThunk('store/getListTrx', async (args, { getState }) => {
    if (args["origin"]=="worldpos"){
        args["action"]= "getTrx";
        args["collection"]= "storesWld";
    }
    const response = await handleWorldpos(args);
    return { response: response.data, statusCode: response.status };
});

export const getAllUsers = createAsyncThunk('store/getAllUsers', async (args, { getState }) => {
    if (args["origin"]=="worldpos"){
        args["action"]= "users";
        args["collection"]= "storesWld";
    }
    const response = await handleWorldpos(args);
    return { response: response.data, statusCode: response.status };
});

export const getListStores = createAsyncThunk('store/getListStores', async (args, { getState }) => {
    if (args["origin"]=="worldpos"){
        args["action"]= "getStores";
        args["collection"]= "storesWld";
    }
    const response = await handleWorldpos(args);
    return { response: response.data, statusCode: response.status };
});

export const sendEmailOtp = createAsyncThunk('store/sendEmailOtp', async (args, { getState }) => {
    args["action"]= "sendEmail";
    const response = await handleWorldpos(args);
    return { response: response.data, statusCode: response.status };
});

export const createOtp = createAsyncThunk('store/createOtp', async (args, { getState }) => {
    args["action"]= "createOtp";
    const response = await handleWorldpos(args);
    return { response: response.data, statusCode: response.status };
});

export const valOtp = createAsyncThunk('store/valOtp', async (args, { getState }) => {
    args["action"]= "valotp";
    args["collection"]= "storesWld";
    const response = await handleWorldpos(args);
    return { response: response.data, statusCode: response.status };
});

export const createInvoice = createAsyncThunk('store/createInvoice', async (args, { getState }) => {
    let walletId= process.env.REACT_APP_WALLET;
    args["action"]= "invoice";
    args["procedure"]= "create";
    args["hostWallet"]= `${walletId}`;
    const response = await handleWorldpos(args);
    return { response: response.data, statusCode: response.status };
});

export const validateInvoice = createAsyncThunk('store/validateInvoice', async (args, { getState }) => {
    args["action"]= "invoice";
    args["procedure"]= "validate";
    const response = await handleWorldpos(args);
    return { response: response.data, statusCode: response.status };
});

export const updateInvoice = createAsyncThunk('store/updateInvoice', async (args, { getState }) => {
    args["action"]= "update";
    args["collection"]= "storesWld";
    const response = await handleWorldpos(args);
    return { response: response.data, statusCode: response.status };
});

// TO VALIDATE ERRORS IN EACH FIELD 
const fieldSetters = {
    email: 'setEmail',
    phone: 'setPhone',
    confirmPhone: 'setConfirmPhone',
    extPhone: 'setPhoneExt',
    dpi: 'setDpi',
    name: 'setUserName',
    last_name: 'setUserLastName',
    country: 'setCountry',
    password: 'setPassword',
    source: 'setUserSource',
    paymentType: 'setUserPaymentType',
    discountCode: 'setUserDiscountCode',
    discountCodePorcent: 'setUserDiscountCodePorcent',
    referalUserDiscountCode: 'setReferalUserDiscountCode'
};

export const storeSlice = createSlice({
    name: 'store',
    initialState: {
        token: { value: "", error: true },
        masterUser: { value: false, error: true },
        procedure: { value: "", error: true },
        pos: { value: "", error: true },
        group: { value: "", error: true },
        storeName: { value: "", error: true },
        country: { value: "", error: true },
        currency: { value: "", error: true },
        idStore: { value: "", error: true },
    },
    reducers: {
        setIdStore: (state, action)=>{
            let Value = action.payload ?? "";
            state.idStore = Value;
        },
        setMasterUser: (state, action)=>{
            let Value = action.payload ?? "";
            state.masterUser = Value;
        },
        setProcedure: (state, action)=>{
            let Value = action.payload ?? "";
            state.procedure = Value;
        },
        setTokenStore: (state, action)=>{
            let Value = action.payload ?? "";
            state.token = Value;
        },
        setPos: (state, action)=>{
            let Value = action.payload ?? "";
            state.pos = Value;
        },
        setGroup: (state, action)=>{
            let Value = action.payload ?? "";
            state.group = Value;
        },
        setStoreName: (state, action)=>{
            let Value = action.payload ?? "";
            state.storeName = Value;
        },
        setCountrySrore: (state, action)=>{
            let Value = action.payload ?? "";
            state.country = Value;
        },
        setCurrencyStore: (state, action)=>{
            let Value = action.payload ?? "";
            state.currency = Value;
        },
    },
})

// Action creators are generated for each case reducer function
export const { setIdStore, setMasterUser, setProcedure, setTokenStore, setPos, setGroup, setStoreName, setCountrySrore, setCurrencyStore } = storeSlice.actions
export default storeSlice.reducer